import React from "react";
import "./UserTable.css";
import { Table, Popconfirm } from "antd";
import { useSelector } from "react-redux";
import lang from "../../../../services/lang";
import avarIcon from "../../../../assets/icons/ic_avatar.png";

const dateFormat = "YYYY-MM-DD HH:mm:ss";
function UserTable(props) {
  const { langIndex } = useSelector((x) => x.app);
  const { userList, deleteUser, onClickEditRecord, onClickGroup } = props;
  const columns = [
    {
      title: lang(langIndex, "plant_userid"),
      dataIndex: "barcode",
      key: "barcode",
    },
    {
      title: lang(langIndex, "plant_username"),
      dataIndex: "username",
      key: "username",
    },
    {
      title: lang(langIndex, "plant_avatar"),
      dataIndex: "user_picture",
      key: "user_picture",
      width: 70,
      render: (user_picture) => {
        return user_picture == "" || user_picture == null ? (
          <img className="user-picture-style" src={avarIcon} alt="avatar" />
        ) : (
          <img className="user-picture-style" src={user_picture} alt="avatar" />
        );
      },
    },
    {
      title: lang(langIndex, "plant_email"),
      dataIndex: "email",
      key: "email",
      render: (email) => {
        if (!email || email.trim() === "") return "-";
        const emails = email.split(";").filter(e => e.trim() !== "");
        return (
          <div style={{ maxWidth: 200 }}>
            {emails.map((e, index) => (
              <div key={index} style={{ fontSize: "12px", marginBottom: index < emails.length - 1 ? "4px" : "0" }}>
                {e.trim()}
              </div>
            ))}
          </div>
        );
      },
    },
    {
      title: lang(langIndex, "plant_phone"),
      dataIndex: "phone",
      key: "phone",
      render: (phone) => {
        if (!phone || phone.trim() === "") return "-";
        const phones = phone.split(";").filter(p => p.trim() !== "");
        return (
          <div style={{ maxWidth: 150 }}>
            {phones.map((p, index) => (
              <div key={index} style={{ fontSize: "12px", marginBottom: index < phones.length - 1 ? "4px" : "0" }}>
                {p.trim()}
              </div>
            ))}
          </div>
        );
      },
    },
    {
      title: lang(langIndex, "plant_securitylevel"),
      dataIndex: "security_level",
      key: "security_level",
      render: (security_level) => {
        switch (security_level) {
          case "4":
            return lang(langIndex, "plant_administrator");
          case "2":
            return lang(langIndex, "plant_client");
          case "0":
            return lang(langIndex, "plant_operator");
          default:
            return lang(langIndex, "plant_operator");
        }
      },
    },
    {
      title: lang(langIndex, "cnc_program_edit_permission"),
      dataIndex: "cnc_program_edit_permission",
      key: "cnc_program_edit_permission",
      align: "center",
      render: (cnc_program_edit_permission) => {
        return cnc_program_edit_permission == "1" ? "On" : "Off";
      },
    },
    {
      title: lang(langIndex, "jobentry_operation"),
      dataIndex: "operation",
      render: (_, record) => {
        return (
          <div>
            <a onClick={() => editRecord(record)}>
              {lang(langIndex, "jobentry_edit")}
            </a>
            <a style={{ marginLeft: 10, color: record.security_level != 4 ? "green" : "grey" }} onClick={() => setGroup(record)}>
              {lang(langIndex, "group")}
            </a>
            <Popconfirm
              title={lang(langIndex, "jobentry_suretodelete")}
              onConfirm={() => deleteRecord(record)}
            >
              <a style={{ marginLeft: 10, color: "red" }}>
                {lang(langIndex, "jobentry_delete")}
              </a>
            </Popconfirm>
          </div>
        );
      },
    },
  ];
  const editRecord = (record) => {
    onClickEditRecord(record);


  };
  const setGroup = (record) => {
    if (record.security_level != 4) {
      onClickGroup(record)
    }
  };
  const deleteRecord = (record) => {
    deleteUser(record.id);
  };

  return (
    <div>
      <Table
        className="user-table-style"
        dataSource={userList}
        columns={columns}
        pagination={{ pageSize: 5 }}
      />
    </div>
  );
}

export default UserTable;
